import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { UserStore } from '../stores/user.store';
import { redirectAfterAuth } from '../../shared/utils/route.utils';

export const emailNotConfirmedGuard: CanActivateFn = () => {
  const userStore = inject(UserStore);
  const router = inject(Router);

  if (!userStore.isConfirmed()) {
    return true;
  }

  redirectAfterAuth(router, userStore.user());
  return false;
};
